import type { ComponentDefinition } from "./types";
import { COMMON_BATTERIES } from "./catalog/common-batteries";
import { BATTERY } from "./catalog/battery";
import { LITIME_BATTERIES } from "./catalog/litime";
import { ENGINE } from "./catalog/engine";
import { SOURCE } from "./catalog/source";
import { CHARGER } from "./catalog/charger";
import { MAGNUM } from "./catalog/magnum";
import { SOLAR } from "./catalog/solar";
import { DISTRIBUTION } from "./catalog/distribution";
import { AC_BREAKERS } from "./catalog/ac-breakers";
import { DC_BREAKERS } from "./catalog/dc-breakers";
import { AC_CIRCUITS } from "./catalog/ac-circuits";
import { RV_AC } from "./catalog/rv-ac";
import { RV_DISTRIBUTION } from "./catalog/rv-distribution";
import { PARALLAX } from "./catalog/parallax";
import { CONTROL_CIRCUITS } from "./catalog/control-circuits";
import { PV_COMBINERS } from "./catalog/pv-combiners";
import { MONITOR } from "./catalog/monitor";
import { LOAD } from "./catalog/load";

export const CATALOG_SEED: ComponentDefinition[] = [
  ...BATTERY,
  ...COMMON_BATTERIES,
  ...LITIME_BATTERIES,
  ...ENGINE,
  ...SOURCE,
  ...CHARGER,
  ...MAGNUM,
  ...SOLAR,
  ...DISTRIBUTION,
  ...AC_BREAKERS,
  ...DC_BREAKERS,
  ...AC_CIRCUITS,
  ...RV_AC,
  ...RV_DISTRIBUTION,
  ...PARALLAX,
  ...CONTROL_CIRCUITS,
  ...PV_COMBINERS,
  ...MONITOR,
  ...LOAD,
];
